<template>
	<div class="display-flex flex-row flex-align-center mt-2 mb-3 flex-justify-space-between">
		<div class="display-flex flex-row">
			<AnemicButton
				v-for="(tab, i) in selectItems"
				:key="tab.value + '_' + i"
				class="tab-button flex-centerize"
				@click="changeTab(tab.value)"
				:class="{ selected: localTab === tab.value }"
			>
				{{ tab.option }}
			</AnemicButton>
		</div>
	</div>
</template>
<script>
export default {
	name: 'SelectTabsCustomInput',
	props: { selectItems: { type: Array }, value: { type: String } },
	data() {
		return { localTab: this.value };
	},
	methods: {
		changeTab(tab) {
			this.localTab = tab;
			this.$emit('change-tab', tab);
		},
	},
};
</script>
<style lang="scss" scoped>
.tab-button {
	border-radius: 6px;
	height: 26px !important;
	font-size: 12px !important;
	padding: 0px 8px !important;
	border: 1px solid #e7eaf3;
	background: #f9fafc !important;
	&.selected {
		margin-left: -3px;
		color: var(--bold-border-color);
		background: var(--bg-color) !important;
		box-shadow: 0px 3px 6px var(--shadow-color) !important;
	}
}
</style>
